import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=0556e96a&scoped=true"
import script from "./appointment.vue?vue&type=script&lang=js"
export * from "./appointment.vue?vue&type=script&lang=js"
import style0 from "./appointment.vue?vue&type=style&index=0&id=0556e96a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0556e96a",
  null
  
)

export default component.exports